<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import HasPagination from 'dashboard-js/mixins/HasPagination'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [HasLoadingState, HasPagination, ManagesModalState, RestoreOnPageBack],

    props: [],

    data() {
        return {
            amount: 2000,
            campaigns: {},
        }
    },

    computed: {
        reach: {
            get() {
                return this.getReachForCost(this.amount)
            },
            set(reach) {
                this.amount = this.getCostForReach(reach)
            },
        },
    },

    created() {
        this.onPageRestore(() => this.load(true))
        this.onPageVisit(() => {
            this.page = 1
            this.load()
        })
    },

    methods: {
        load(silently) {
            axios
                .get('/api/campaigns', { params: this.params() })
                .then(response => {
                    this.paginate(response.data)
                    this.campaigns = response.data
                })
                .then(this.finishLoading(silently))
                .then(this.saveState)
        },

        params() {
            return {
                page: this.page,
            }
        },
    },
}
</script>
